import * as React from "react";
import { connect } from "react-redux";

import OnboardingHeading from "./OnboardingHeading";

class OnboardingMainContent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            children,
            pageHeading
        } = this.props;

        return (
            <>
                <div className="row onboarding-layout__main-content">
                    {pageHeading &&
                        <OnboardingHeading pageHeading={pageHeading} />
                    }
                    {children}       
                </div>                
            </>
        );
    }
}

const mapStateToProps = (state) => {    
    return {

    };
};
const mapDispatchToProps = (dispatch) => {
    return {

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OnboardingMainContent);

